/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Embed from '../partials/Embed';
import FloatingVideoSlot from '../partials/FloatingVideoSlot';

import styles from '../../../styles/blocks/video.module.scss';

const propTypes = {
    video: PropTypes.shape({
        embed: AppPropTypes.embed,
        media: AppPropTypes.video,
    }),
    isContainer: PropTypes.bool,
    isVideoSlot: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    video: null,
    isContainer: false,
    isVideoSlot: false,
    className: null,
};

const VideoBlock = ({ video, isVideoSlot, isContainer, className }) => {
    const { embed = null, media = null } = video || {};
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isContainer]: isContainer,
                    [className]: className !== null,
                },
            ])}
        >
            {isVideoSlot ? (
                <FloatingVideoSlot name="video" className={styles.videoSlot} fullWidth />
            ) : (
                <Embed embed={embed || media} fullWidth withControls />
            )}
        </div>
    );
};

VideoBlock.propTypes = propTypes;
VideoBlock.defaultProps = defaultProps;

export default VideoBlock;
